import type { BreadcrumbItem, NavItem } from '@/lib/types';

export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/', breadcrumb: 'Dashboard', icon: 'LayoutDashboard' },
  { label: 'Data', path: '/data', breadcrumb: 'Data', icon: 'Database' },
  { label: 'Strategies', path: '/strategies', breadcrumb: 'Strategies', icon: 'Code' },
  { label: 'Backtests', path: '/backtests', breadcrumb: 'Backtests', icon: 'Play' },
];

export const usersNavItem: NavItem = {
  label: 'Users',
  path: '/users',
  breadcrumb: 'Users',
  icon: 'Users',
};

export function getNavItems(isAdmin: boolean) {
  return isAdmin ? [...navItems, usersNavItem] : navItems;
}

export function resolveActiveNavPath(pathname: string) {
  if (pathname === '/') return '/';
  const match = [...navItems, usersNavItem]
    .filter((item) => item.path !== '/')
    .find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`));
  return match?.path ?? pathname;
}

export function isNavItemActive(pathname: string, itemPath: string) {
  return resolveActiveNavPath(pathname) === itemPath;
}

export function isStrategyBuilderPath(pathname: string) {
  return pathname === '/strategies/new' || /^\/strategies\/[^/]+\/edit$/.test(pathname);
}

export function strategyBuilderPath(strategyId?: string | null) {
  return strategyId
    ? `/strategies/${encodeURIComponent(strategyId)}/edit`
    : '/strategies/new';
}

export function getBreadcrumbs(pathname: string, activeDatasetName?: string): BreadcrumbItem[] {
  if (pathname.startsWith('/data/')) {
    return [
      { label: 'Data', path: '/data' },
      { label: activeDatasetName || 'Dataset details' },
    ];
  }

  if (pathname.startsWith('/backtests/')) {
    return [{ label: 'Backtests', path: '/backtests' }, { label: 'Run detail' }];
  }

  if (pathname === '/strategies/new') {
    return [{ label: 'Strategies', path: '/strategies' }, { label: 'New strategy' }];
  }

  if (/^\/strategies\/[^/]+\/edit$/.test(pathname)) {
    return [{ label: 'Strategies', path: '/strategies' }, { label: 'Strategy editor' }];
  }

  const activeItem = [...navItems, usersNavItem]
    .find((item) => item.path === resolveActiveNavPath(pathname));
  return [{ label: activeItem?.breadcrumb ?? activeItem?.label ?? 'Dashboard' }];
}
